import { NgModule } from '@angular/core';
import { SourceMarqueursIntoLegendPipe } from './source-marqueurs-into-legend.pipe';
import { ElementEditionOnPipe } from './element-edition-on.pipe';



@NgModule({
  declarations: [
    ElementEditionOnPipe,
    SourceMarqueursIntoLegendPipe,
  ],
  exports: [
    ElementEditionOnPipe,
    SourceMarqueursIntoLegendPipe,
  ]
})
export class MarqueursLegendeModule { }
